import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/boat/src/components/ui/coming-soon.tsx");
